 
import Pricing from './Pricing';
  
const PaymentMethodStep = ({ email  }) => {
     
  
    return (
     <Pricing email={email}/>
    );
  };

  export default PaymentMethodStep;